/**
 * العربية — مسارات `/ar/…` ومحلية CMS `ar`.
 */
const translationsAr = {
  logoMark: 'AI Restro 360',
  nav: {
    merge: 'نقطة البيع والطلبات',
    split: 'المطبخ والمخزون',
    compress: 'التوصيل والضيوف',
    convert: 'التحليلات والذكاء الاصطناعي',
    login: 'تسجيل الدخول',
    logIn: 'تسجيل الدخول',
    dashboard: 'لوحة التحكم',
    signUp: 'إنشاء حساب',
    home: 'الرئيسية',
  },
  title: 'AI Restro 360 — نظام تشغيل للمطاعم السريعة',
  /** Home `<title>` / OG; hero `<h1>` uses `landing` headline strings. */
  seoHeroH1: 'AI Restro 360 — نظام تشغيل للمطاعم السريعة',
  subtitle:
    'نقطة بيع سحابية مع شاشة مطبخ وتتبع سائقين ومخزون وتقارير — نظام واحد للخدمة المزدحمة.',
  selectPdf: 'إضافة ملف',
  orDrop: 'أو أسقط الملف هنا',
  fromCloud: 'من السحابة',
  otherSources: 'مصادر أخرى',
  fileProtection: '✓ حماية الملفات مفعّلة',
  addMoreFiles: 'إضافة ملفات',
  removeFile: 'إزالة',
  dpi: 'DPI',
  imageQuality: 'جودة الصورة',
  color: 'اللون',
  colorNoChange: 'بدون تغيير',
  colorGray: 'رمادي',
  compress: 'تطبيق',
  compressing: 'جارٍ المعالجة…',
  resultReduced: 'انخفض الحجم بمقدار',
  shareOrContinue: 'مشاركة أو متابعة',
  download: 'تنزيل',
  preview: 'معاينة',
  erase: 'مسح النتيجة',
  restart: 'إعادة البدء',
  googleDrive: 'Google Drive',
  dropbox: 'Dropbox',
  email: 'البريد الإلكتروني',
  mailSubject: 'ملفك جاهز',
  mailBody: 'تنزيل:',
  footer: '© 2026 – Powered by ApimsTec',
  footerProduct: 'المنتج',
  footerResources: 'المصادر',
  footerLegal: 'قانوني',
  footerCompany: 'الشركة',
  footerHome: 'الرئيسية',
  footerFeatures: 'الميزات',
  footerPricing: 'الأسعار',
  footerFaq: 'الأسئلة الشائعة',
  footerTools: 'الأدوات',
  footerSolutions: 'الحلول',
  footerBusiness: 'الأعمال',
  footerEducation: 'التعليم',
  footerSecurity: 'الأمان',
  footerPress: 'الصحافة',
  footerPrivacy: 'سياسة الخصوصية',
  footerTerms: 'الشروط والأحكام',
  footerDisclaimer: 'إخلاء المسؤولية',
  footerCookies: 'ملفات تعريف الارتباط',
  footerAbout: 'من نحن',
  footerContact: 'اتصل بنا',
  footerBlog: 'المدونة',
  footerOther: 'أخرى',
  footerCopyrightPrefix: '© AI Restro 360 2026 – ',
  footerPoweredBy: 'بدعم من Apimstec',
  footerLanguage: 'العربية',
  footerGetGooglePlay: 'احصل عليه من Google Play',
  footerDownloadAppStore: 'تنزيل من App Store',
  footerDownloadMacStore: 'تنزيل من Mac App Store',
  footerMicrosoftStore: 'Microsoft Store',
  footerCopyrightFull: 'حقوق النشر © 2026 AI Restro 360. جميع الحقوق محفوظة.',
  footerAddressLine: 'نخدم فرق الضيافة حول العالم.',
  footerRegionGlobal: 'عالمي',
  footerRegionAria: 'اختر المنطقة',
  footerChatAria: 'اتصل بنا',
  footerColResources: 'الموارد',
  footerHelpCenter: 'مركز المساعدة',
  footerDocumentation: 'التوثيق',
  footerCaseStudies: 'دراسات الحالة',
  footerProductNews: 'تحديثات المنتج',
  footerEvents: 'الفعاليات',
  footerCommunity: 'المجتمع',
  footerCookiePolicy: 'سياسة ملفات تعريف الارتباط',
  footerLegalAbout: 'قانوني: عن الشركة',
  footerColSolutions: 'الحلول',
  footerColIntegrations: 'التكاملات',
  footerColFor: 'AI Restro 360 من أجل',
  footerCareers: 'الوظائف',
  footerCustomerStories: 'قصص العملاء',
  footerNewsletter: 'الاشتراك في النشرة',
  footerTermsOfService: 'شروط الخدمة',
  footerPrivacyCookieNotice: 'الخصوصية وإشعار ملفات تعريف الارتباط',
  footerSolSentinel: 'Sentinel',
  footerSolDeliveryApp: 'تطبيق إدارة التوصيل',
  footerSolDirect: 'Direct',
  footerSolDispatch: 'الإرسال',
  footerSolKiosk: 'كشك',
  footerSolTableOrdering: 'طلبات الطاولة',
  footerSolQuestApp: 'تطبيق Quest',
  footerIntAll: 'جميع التكاملات',
  footerIntPos: 'أنظمة نقطة البيع',
  footerInt3p: 'أسواق الطلبات',
  footerIntOnline: 'الطلب عبر الإنترنت',
  footerIntRetail: 'التجزئة',
  footerIntLoyalty: 'الولاء وإدارة علاقات العملاء',
  footerIntPartner: 'كن شريكاً',
  footerForRestaurants: 'المطاعم',
  footerForRetail: 'التجزئة',
  footerForEnterprise: 'المؤسسات',
  ariaSelectPdf: 'اختر الملفات',
  ariaColorMode: 'وضع الألوان',
  ariaRemove: 'إزالة',
  compressionSettings: 'إعدادات المعالجة',
  compressionResult: 'النتيجة',
  progressInitializing: 'جارٍ البدء…',
  progressLoading: 'جارٍ التحميل…',
  progressPage: 'جارٍ المعالجة…',
  progressFinalizing: 'جارٍ الإنهاء…',
  progressGrayscale: 'جارٍ تطبيق الخيارات…',
  maxFilesReached: 'لقد وصلت إلى الحد الأقصى 10 ملفات. احذف ملفاً لإضافة آخر.',
  maxFilesPartial: 'أُضيفت الملفات التي تتسع فقط (حد أقصى 10).',
  maxFilesHint: 'حد أقصى 10 ملفات لكل جلسة.',
  fileCountHint: '{count} من {max} ملفاً محدداً',
  settingsRequiredHint: 'أكمل الحقول المطلوبة للمتابعة.',
  fileDone: 'تم',
  compressFileProgress: 'الملف {current} من {total}: {name}',
  resultMultiTitle: 'ملفاتك جاهزة',
  resultSavedSuffix: 'أصغر',
  fromTheBlog: 'من المدونة',
  viewAllPosts: 'عرض كل المقالات',
  downloadAll: 'تنزيل الكل',
  otherTools: 'أدوات أخرى',
  landing: {
    heroTitleLine1: 'توقف عن خسارة ',
    heroTitleAccent1: 'المال',
    heroTitleLine2: ' في كل ',
    heroTitleAccent2: 'ساعة ازدحام.',
    heroSubtitle:
      'كل طلب ضائع وكل ورقة وكل سائق لا تتابعه يكلفك مالاً. يمنحك AI Restro 360 شاشة واحدة لنقطة البيع والمطبخ والسائقين والمخزون — مباشرة طوال اليوم.',
    heroTrust: 'بدون بطاقة. بدون أجهزة. إعداد في يوم واحد.',
    cineTitle: 'موسم ساعة الذروة.',
    cineSubtitle:
      'اكتشف AI Restro 360 — نقطة البيع والمطبخ والسائقون على شاشة واحدة. مصمم للذروة، ولكل وردية بعدها.',
    cineCtaTrial: 'ابدأ التجربة المجانية',
    cineCtaDemo: 'احجز عرضاً',
    cineOfferAria: 'إعلان المنتج',
    cineOfferBefore: 'جديد — Farori، مساعدك الذكي، هنا.',
    cineOfferLogin: 'تسجيل الدخول',
    cineOfferOr: 'أو',
    cineOfferStart: 'ابدأ مجاناً',
    cinePauseVideo: 'إيقاف فيديو الخلفية',
    cinePlayVideo: 'تشغيل فيديو الخلفية',
    ctaCompress: 'ابدأ مجاناً — 30 يوماً',
    featuresTitle: 'نظام واحد. كل جزء متحرك.',
    feature1Title: 'فوضى ساعة الذروة',
    feature1Desc:
      'تتراكم الطلبات ويضيع المطبخ وينتظر السائقون وتخرج أصناف خاطئة. طابور مباشر يبقي الجميع متوافقاً.',
    feature2Title: 'أوراق في كل مكان',
    feature2Desc:
      'دفاتر ولقطات واتساب وإيصالات يدوية تخفي الأرقام الحقيقية. شاهد المبيعات والهدر في مكان واحد.',
    feature3Title: 'سائقون بلا تتبع',
    feature3Desc:
      'اعرف من معه أي طلب وأي نقد جُمع — كل توصيل مسجّل وكل روبية محسوبة.',
    feature4Title: 'مفاجآت المخزون',
    feature4Desc:
      'النفاد أثناء الخدمة يضر أكثر من تذكرة بطيئة. يبقى المخزون مرتبطاً بما تبيعه فعلاً.',
    howTitle: 'من الصفر إلى أول طلب في يوم واحد',
    howStep1: 'سجّل مجاناً',
    howStep1Desc: 'أنشئ حسابك في دقائق. بلا دفع ولا بطاقة ولا أوراق.',
    howStep2: 'نبني قائمتك',
    howStep2Desc: 'شارك القائمة — نضيف كل فئة وصنف وسعر.',
    howStep3: 'أضف فريقك',
    howStep3Desc: 'أنشئ حسابات الكاشير والمطبخ والسائقين بأدوار واضحة بنقرة واحدة.',
    howStep4: 'ابدأ استقبال الطلبات',
    howStep4Desc: 'افتح المتصفح. مطعمك مباشر. أول طلب خلال أقل من خمس دقائق.',
    faqButtonFallback: 'سؤال {n}',
    faqTitle: 'الأسئلة الشائعة',
    faq1Q: 'هل هناك فترة تجريبية؟',
    faq1A:
      'نعم — 30 يوماً مجاناً بكامل الميزات. بلا بطاقة، والتجربة لا تتحول تلقائياً إلى اشتراك مدفوع.',
    faq2Q: 'هل أحتاج أجهزة خاصة؟',
    faq2A:
      'لا. يعمل AI Restro 360 في المتصفح على أي هاتف أو جهاز لوحي أو حاسوب.',
    faq3Q: 'كم يستغرق الإطلاق؟',
    faq3A:
      'معظم المواقع تنتقل من التسجيل إلى أول طلب في يوم واحد. نساعد في القائمة وحسابات الفريق.',
    faq4Q: 'هل يمكنني الإلغاء في أي وقت؟',
    faq4A:
      'الخطط الشهرية تُلغى في أي وقت. بياناتك ملكك — صدّرها عند الحاجة.',
    readyTitle: 'هل أنت مستعد لإيقاف تسرب ساعة الذروة؟',
    readySubtitle: 'ابدأ مجاناً 30 يوماً، أو احجز عرضاً قصيراً مع فريقنا.',
    cmsSectionAria: 'مقدمة الموقع',
    arHeroEyebrow: 'نظام تشغيل للمطاعم السريعة',
    arStatsAria: 'أبرز النقاط',
    arStat1Value: 'Rs 0',
    arStat1Label: 'أجهزة مطلوبة',
    arStat2Value: 'يوم واحد',
    arStat2Label: 'وقت الإطلاق',
    arStat3Value: '30 يوماً',
    arStat3Label: 'وصول مجاني كامل',
    arTestimonialQuote:
      'شاشة واحدة لنقطة البيع والمطبخ والسائقين والمخزون — الأمام والمكتب الخلفي متوافقان أخيراً.',
    arQuoteBadge: 'مصمم للخدمة المزدحمة',
    arContactLink: 'احجز عرضاً',
    arFaqSubtitle: 'إجابات مباشرة لأصحاب المطاعم والمديرين عند إطلاق AI Restro 360.',
    arFaqCta: 'اتصل بنا',
    arFaqViewAll: 'انتقل إلى الأسئلة',
    arWhatTitle: 'ما يستنزف أرباحك',
    arWhyTitle: 'مطعمك يخسر مالاً بطرق قد لا تلاحظها.',
    arWhoTitle: 'لمن هذا',
    arWho1Title: 'الوجبات السريعة والتيك أواي',
    arWho1Desc:
      'الكاونتر والتوصيل وتذاكر المطبخ في تدفق واحد — بلا كومة أوراق.',
    arWho2Title: 'المقاهي وأكشاك الشاي',
    arWho2Desc:
      'نقطة بيع بسيطة وتقارير واضحة ومخزون يناسب فريقاً صغيراً وكاونتراً مزدحماً.',
    arWho3Title: 'مجموعات متعددة الفروع',
    arWho3Desc:
      'نفس أسلوب العمل عبر المواقع — قوائم وأدوار وأرقام نهاية اليوم التي تتطابق فعلاً.',
    arIntegrationsTitle: 'يعمل مع طريقة بيعك الحالية',
    arIntegrationsSub:
      'نقطة البيع وشاشة المطبخ والسائقون والمدفوعات وبيانات الضيوف على خط زمني تشغيلي واحد.',
    arIntLogo1: 'نقطة البيع',
    arIntLogo2: 'المطبخ',
    arIntLogo3: 'السائقون',
    arIntLogo4: 'المخزون',
    arIntLogo5: 'التقارير',
    arDualTitle: 'استكشف المنصة واحصل على الدعم',
    arCtaCard1Title: 'الحلول',
    arCtaCard1Desc: 'اطلع على وحدات نقطة البيع والمطبخ والتوصيل والنمو المصممة للخدمة الحقيقية.',
    arCtaCard2Title: 'تحدث معنا',
    arCtaCard2Desc: 'الإعداد أو الفروع المتعددة أو عرض سريع — نحن جاهزون للمساعدة.',
    arExploreLink: 'استكشف',
    arGetStarted: 'ابدأ مجاناً — 30 يوماً',
    homePricingTitle: 'أسعار شهرية بسيطة لكل الفروع',
    homePricingSub:
      'سعر واحد بالدولار يغطي كل فروعك. اختر باقة جاهزة أو ابنِ فاتورتك بالحاسبة.',
    guaranteeTitle: 'ابدأ بلا مخاطر',
    guarantee1Title: '30 يوماً مجاناً',
    guarantee1Desc: 'وصول كامل للميزات، بلا بطاقة، بلا التزام.',
    guarantee2Title: 'نحن نعدّه',
    guarantee2Desc: 'القائمة والفريق والنظام جاهزون في اليوم الأول.',
    guarantee3Title: 'بلا أجهزة',
    guarantee3Desc: 'أي هاتف أو جهاز لوحي أو حاسوب — يكفي المتصفح.',
    guarantee4Title: 'ألغِ في أي وقت',
    guarantee4Desc: 'خطط شهرية. بياناتك دائماً ملكك للتصدير.',
  },
  tools: {
    pageTitle: 'المنصة والحلول',
    frequentlyUsed: 'الأكثر استخداماً',
    mergePdf: 'نقطة البيع',
    splitPdf: 'المطبخ و KDS',
    compressPdf: 'التوصيل والأسواق',
    editPdf: 'القائمة والأسعار',
    signPdf: 'الطاقم والدوام',
    convertPdf: 'المخزون والمشتريات',
    imagesToPdf: 'الحجوزات',
    pdfToImages: 'ملف الضيف',
    extractImages: 'الولاء وإدارة العملاء',
    protectPdf: 'منع الخسائر',
    unlockPdf: 'الصلاحيات والأدوار',
    rotatePdf: 'طلبات الطاولة وQR',
    removePages: 'الدرايف ثرو والكشك',
    extractPages: 'التموين والفعاليات',
    rearrangePages: 'تقارير متعددة المواقع',
    webpageToPdf: 'التسويق والحملات',
    pdfOcr: 'التنبؤ والذكاء الاصطناعي',
    addWatermark: 'إيصالات العلامة',
    addPageNumbers: 'سجل التدقيق',
    pdfOverlay: 'واجهة برمجة والتصدير',
    comparePdfs: 'المقارنة',
    webOptimize: 'تكاملات مفتوحة',
    redactPdf: 'الامتثال والسياسات',
    createPdf: 'الإعداد',
    translatePdf: 'دعم 24/7',
    jpgToPdf: 'إدارة الطاولات',
    wordToPdf: 'مسارات الدفع',
    powerpointToPdf: 'أدوات الامتياز',
    excelToPdf: 'كتالوج الموردين',
    htmlToPdf: 'واي فاي ومراجعات الضيوف',
    pdfToJpg: 'أجهزة المتجر',
    pdfToWord: 'وضع التدريب',
    pdfToPowerpoint: 'تشغيل الامتياز',
    pdfToExcel: 'حساب التكلفة',
    pdfToPdfa: 'إقامة البيانات',
  },
  megaMenu: {
    organizePdf: 'الواجهة الأمامية',
    optimizePdf: 'عمليات المطبخ',
    convertToPdf: 'التوصيل والضيوف',
    convertFromPdf: 'النمو والولاء',
    editPdf: 'المخزون',
    pdfSecurity: 'الصلاحيات',
    pdfIntelligence: 'التحليلات والذكاء الاصطناعي',
  },
  pricing: {
    title: 'الأسعار',
    intro:
      'أسعار بالدولار لجميع الفروع. ابدأ بنواة نقطة البيع أو الباقة الكاملة أو اخلط الإضافات — بما فيها مساعد الاستقبال الذكي (Farori) بـ 19$/شهر.',
    ctaContact: 'اتصل بالمبيعات',
    ctaRegister: 'ابدأ',
  },
  about: {
    title: 'عن AI Restro 360',
    intro:
      'نبني نظام تشغيل سحابي للمطاعم السريعة والمقاهي والتيك أواي — لتبقى نقطة البيع والمطبخ والسائقون والمخزون على شاشة واحدة.',
    ctaContact: 'تحدث معنا',
  },
  contact: {
    title: 'اتصل بنا',
    description: 'تواصل مع فريق AI Restro 360.',
    intro:
      'اسأل عن عرض أو الإعداد أو الفروع المتعددة أو الدعم. نرد من إسلام آباد ونعمل مع المطاعم في باكستان وخارجها.',
    detailsHeading: 'تفاصيل الاتصال',
    sendAnother: 'إرسال رسالة أخرى',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    backHome: 'العودة للرئيسية',
    noDetails: 'تفضل البريد أو واتساب؟ تواصل عبر support@airestro360.com أو +92 301 2775034.',
    yourName: 'الاسم',
    yourEmail: 'البريد الإلكتروني',
    subject: 'الموضوع',
    chooseSubject: 'اختر الموضوع…',
    message: 'الرسالة',
    writeMessage: 'كيف يمكننا المساعدة؟',
    iAccept: 'أوافق على',
    termsAndConditions: 'الشروط والأحكام',
    legalPrivacy: 'القانون والخصوصية',
    sendMessage: 'إرسال الرسالة',
    successMessage: 'تم إرسال رسالتك. سنتواصل معك قريباً.',
    errorSend: 'تعذّر إرسال الرسالة. حاول مرة أخرى.',
    errorTerms: 'يجب قبول الشروط والأحكام والقانون والخصوصية لإرسال النموذج.',
    subjectGeneral: 'استفسار عام',
    subjectSupport: 'الدعم',
    subjectFeedback: 'ملاحظات',
    subjectOther: 'أخرى',
  },
  notFound: {
    title: 'الصفحة غير موجودة',
    body: 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
    backHome: 'العودة للرئيسية',
  },
  cookieConsent: {
    title: 'خصوصيتك مهمة',
    body: 'نستخدم ملفات تعريف الارتباط لتشغيل هذا الموقع وتحسين خدماتنا. اختر الضرورية فقط، أو قبول الكل.',
      policyLink: 'Cookie policy',
    necessaryOnly: 'الضرورية فقط',
    acceptAll: 'قبول الكل',
  },
  breadcrumb: {
    result: 'النتيجة',
    page: 'صفحة',
    legal: 'قانوني',
    solutions: 'الحلول',
    integrations: 'التكاملات',
    resources: 'الموارد',
  },
  blog: {
    listTitle: 'المدونة',
    listIntro:
      'أدلة وملاحظات منتج لأصحاب المطاعم — نقطة البيع وتدفق المطبخ والتوصيل وتشغيل خدمة أضيق.',
    readMore: 'اقرأ المزيد',
    noPosts: 'لا توجد مقالات بعد.',
    emptyTitle: 'لا مقالات حتى الآن',
    emptyBody:
      'مقالات جديدة في الطريق. عد لاحقاً لنصائح تشغيل المطاعم وتحديثات المنتج ورؤى عملية.',
    backHome: 'العودة للرئيسية',
    backToBlog: 'العودة للمدونة',
  },
}

export default translationsAr
